/**
 * Topographic contour-line backdrop. Instrument-aesthetic, not
 * marketing-blob. Two stacked SVGs: dotted topo curves at very low
 * opacity, and a subtle radial wash from accent-500. Pure CSS-friendly
 * SVG so it doesn't cost anything at runtime.
 */
export function TopoBackground() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      {/* Radial wash — soft signal-blue, never overpowers content */}
      <div
        className="absolute inset-0 opacity-[0.55]"
        style={{
          background:
            'radial-gradient(60% 50% at 75% 30%, rgba(10,91,255,0.10) 0%, rgba(10,91,255,0.04) 35%, transparent 70%)',
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.45]"
        style={{
          background:
            'radial-gradient(45% 45% at 18% 85%, rgba(180,90,255,0.06) 0%, transparent 60%)',
        }}
      />

      {/* Topo contours — extracted to an SVG path so it stays sharp at all sizes */}
      <svg
        className="absolute inset-0 h-full w-full opacity-[0.32]"
        viewBox="0 0 1600 900"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="topoFade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0A5BFF" stopOpacity="0.45" />
            <stop offset="100%" stopColor="#0A5BFF" stopOpacity="0" />
          </linearGradient>
          <pattern id="dots" x="0" y="0" width="22" height="22" patternUnits="userSpaceOnUse">
            <circle cx="1" cy="1" r="0.7" fill="#0A5BFF" fillOpacity="0.18" />
          </pattern>
        </defs>

        <rect width="1600" height="900" fill="url(#dots)" />

        <g stroke="url(#topoFade)" strokeWidth="1.1" fill="none">
          <path d="M-100,700 C 240,520 520,720 820,560 C 1140,390 1380,540 1700,420" />
          <path d="M-100,760 C 200,600 540,780 860,620 C 1180,460 1400,600 1700,490" />
          <path d="M-100,820 C 220,680 580,840 920,690 C 1240,540 1430,680 1700,580" />
          <path d="M-100,880 C 260,760 620,910 980,770 C 1300,640 1450,760 1700,660" />
        </g>
        <g stroke="#0A5BFF" strokeOpacity="0.10" strokeWidth="0.8" fill="none">
          <path d="M-100,200 C 240,40 520,260 820,120 C 1140,-30 1380,90 1700,0" />
          <path d="M-100,260 C 200,120 540,320 860,180 C 1180,40 1400,160 1700,70" />
          <path d="M-100,320 C 220,200 580,380 920,240 C 1240,100 1430,220 1700,140" />
        </g>
      </svg>
    </div>
  );
}
